import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import {
  addScreenReaderNotification,
  selectLoading,
  selectWidgetMode,
} from 'reducers/workflows';

export default function useAnnounceLoading() {
  const dispatch = useAppDispatch();
  const widgetMode = useAppSelector(selectWidgetMode);
  const loading = useAppSelector(selectLoading);

  const isLoading = widgetMode === 'workflow' && loading;

  useEffect(() => {
    const loadingMessageTimeout = setTimeout(() => {
      if (isLoading) {
        dispatch(addScreenReaderNotification('Loading'));
      }
    }, 2000);

    const stillLoadingMessageTimeout = setTimeout(() => {
      if (isLoading) {
        dispatch(addScreenReaderNotification('Still loading'));
      }
    }, 7000);

    return () => {
      clearTimeout(loadingMessageTimeout);
      clearTimeout(stillLoadingMessageTimeout);
    };
  }, [dispatch, isLoading]);
}
